import { render } from "./MainSliderSlide.vue?vue&type=template&id=c979339c"
import script from "./MainSliderSlide.vue?vue&type=script&lang=js"
export * from "./MainSliderSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__